import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.real_user = $('.real-user', this.$el);
    this.lazy_user = $('.lazy-user', this.$el);
    this.user_nav = $('#user-nav', this.$el);
    this.username = $('.dropdown-toggle span', this.user_nav);
  },

  logged_in: function (username) {
    // Make changes so the nav is geared towards logged in users
    GLOBALS.IS_LAZY_USER = false;
    this.lazy_user.addClass('hidden');
    this.user_nav.addClass('loggedin-nav');
    this.username.text(username);
    this.real_user.removeClass('hidden');
  }
});



// WEBPACK FOOTER //
// ./static/js/views/nav.js